"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
let CloumnUsername = class extends Mixins(AccountSessionMixins) {
  created() {
    return __async(this, null, function* () {
    });
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  editShop() {
    this.$emit("editShop", this._column);
  }
  get show() {
    if (this._controller.query.filter.group === "shopgroup_system_recycle") {
      return false;
    }
    return true;
  }
  handleAccount(account) {
    if (account.indexOf("@") !== -1) {
      let arr = account.split("@");
      let front = arr[0];
      if (front.length > 4) {
        let new_account = front.substring(0, 2) + "***" + front.substring(front.length - 2, front.length) + "@" + arr[1];
        return new_account;
      } else {
        if (front.length === 1) {
          let new_account = front + "***@" + arr[1];
          return new_account;
        } else if (front.length === 2) {
          let new_account = front.substring(0, 1) + "***" + front.substring(front.length - 1, front.length) + "@" + arr[1];
          return new_account;
        } else {
          let new_account = front.substring(0, 2) + "***" + front.substring(front.length - 1, front.length) + "@" + arr[1];
          return new_account;
        }
      }
    } else {
      if (account.length > 4) {
        let new_account = account.substring(0, 2) + "***" + account.substring(account.length - 2, account.length);
        return new_account;
      } else {
        if (account.length === 1) {
          let new_account = account + "***";
          return new_account;
        } else if (account.length === 2) {
          let new_account = account.substring(0, 1) + "***" + account.substring(account.length - 1, account.length);
          return new_account;
        } else {
          let new_account = account.substring(0, 2) + "***" + account.substring(account.length - 1, account.length);
          return new_account;
        }
      }
    }
  }
};
__decorateClass([
  PropSync("column")
], CloumnUsername.prototype, "_column", 2);
__decorateClass([
  PropSync("controller")
], CloumnUsername.prototype, "_controller", 2);
CloumnUsername = __decorateClass([
  Component({
    components: {}
  })
], CloumnUsername);
export {
  CloumnUsername as default
};
